import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=22b9d771&scoped=true&"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseOrder.vue?vue&type=style&index=0&id=22b9d771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9d771",
  null
  
)

export default component.exports